<template>
  <div class="waiting-room">
    <h3 class="id">Waiting For Other Players</h3>
    <h1>room ID: {{ roomData.roomId }}</h1>
    <div :key="user.playerSocketId" v-for="user in roomData.players">
      <img
        :src="require('@/assets/images/' + user.avatar + '.png')"
        class="player-avatar"
      />
      <div class="li">
        {{ user.playerName }}
      </div>
    </div>

    <div v-if="roomData.isCustomRoom">
      <h2 class="li">{{ customRoomURL }}</h2>
      <button class="copy" @click="copyLink">Copy Link!</button>
    </div>
  </div>
</template>

<script>
  import * as socketio from '../plugins/socketio';
  export default {
    data() {
      return {
        roomData: '',
        customRoomURL: '',
      };
    },
    name: 'UserList',
    mounted() {
      socketio.addEventListener({
        type: 'roomState',
        callback: (roomData) => {
          this.roomData = roomData;
          // put the website url instead of localhost
          this.customRoomURL = `https://doodle-io.web.app/?id=${roomData.roomId}`;
          // this.customRoomURL = `http://localhost:8080/?id=${roomData.roomId}`;
        },
      });
    },
    methods: {
      copyLink() {
        navigator.clipboard.writeText(this.customRoomURL);
      },
    },
  };
</script>

<style scoped>
  .waiting-room {
    color: black;
    justify-content: center;
    display: flex;
    flex-direction: column;
    list-style: none;
    list-style-type: none;
    background: white;
    width: 300px;
    height: 450px;
    /* margin-left: 10px;*/
    margin: auto;
    margin-top: 30px;
    border-radius: 10px;
    overflow-y: auto;
    padding-top: 10px;
  }
  .player-avatar {
    width: 100px;
    display: block;
    margin: auto;
  }
  .li {
    font-family: 'Glory';
    display: block;
    margin: auto;
    font-weight: bolder;
    font-size: 1.5em;
    color: black;
  }
  .copy {
    margin-top: 10px;
    padding: 10px 8px;
    background: rgb(5, 236, 120);
    color: white;
    font-family: 'poppins';
    border-radius: 5px;
    border: 1px solid white;
    cursor: pointer;
    font-weight: bolder;
    justify-content: center;
  }
</style>
